<template>
  <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="dialog()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Placeholder for Document Name</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="dialog = false"></v-btn>
          </v-toolbar-items>
        </v-toolbar>
        Report goes here.
        Arguments passed are {{args}}
  </v-card>
</template>

<script>
export default {
  props: ['show', 'args'],
  methods: {
    dialog (val) {
      this.$emit('update:show', false)
    }
  }
}
</script>